import {
  createStaffMember as publicCreateStaffMember,
  getStaffMember as publicGetStaffMember,
  getDeletedStaffMember as publicGetDeletedStaffMember,
  listDeletedStaffMembers as publicListDeletedStaffMembers,
  removeStaffMemberFromTrashBin as publicRemoveStaffMemberFromTrashBin,
  updateStaffMember as publicUpdateStaffMember,
  deleteStaffMember as publicDeleteStaffMember,
  queryStaffMembers as publicQueryStaffMembers,
  typedQueryStaffMembers as publicTypedQueryStaffMembers,
  countStaffMembers as publicCountStaffMembers,
  connectStaffMemberToUser as publicConnectStaffMemberToUser,
  searchStaffMembers as publicSearchStaffMembers,
  disconnectStaffMemberFromUser as publicDisconnectStaffMemberFromUser,
  assignWorkingHoursSchedule as publicAssignWorkingHoursSchedule,
  assignCustomSchedule as publicAssignCustomSchedule,
  bulkUpdateStaffMemberTags as publicBulkUpdateStaffMemberTags,
  bulkUpdateStaffMemberTagsByFilter as publicBulkUpdateStaffMemberTagsByFilter,
} from './bookings-staff-v1-staff-member-staff-members.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryStaffMembersOptions,
  StaffMemberQuery,
  StaffMembersQueryBuilder,
  typedQueryStaffMembers as universalTypedQueryStaffMembers,
} from './bookings-staff-v1-staff-member-staff-members.universal.js';
import { onStaffMemberConnectedToUser as publicOnStaffMemberConnectedToUser } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberCreated as publicOnStaffMemberCreated } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberDeleted as publicOnStaffMemberDeleted } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberDisconnectedFromUser as publicOnStaffMemberDisconnectedFromUser } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberFullyCreated as publicOnStaffMemberFullyCreated } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberTagsModified as publicOnStaffMemberTagsModified } from './bookings-staff-v1-staff-member-staff-members.public.js';
import { onStaffMemberUpdated as publicOnStaffMemberUpdated } from './bookings-staff-v1-staff-member-staff-members.public.js';

function customQueryStaffMembers(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryStaffMembersOptions) =>
      publicQueryStaffMembers(httpClient)(options),
    typedQueryFunction: (
      query: StaffMemberQuery,
      options?: QueryStaffMembersOptions
    ) => publicTypedQueryStaffMembers(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: StaffMemberQuery,
    options?: QueryStaffMembersOptions
  ): ReturnType<typeof universalTypedQueryStaffMembers>;
  function overloadedQuery(
    options?: QueryStaffMembersOptions
  ): StaffMembersQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: StaffMemberQuery | QueryStaffMembersOptions,
    options?: QueryStaffMembersOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createStaffMember: MaybeContext<
  BuildRESTFunction<typeof publicCreateStaffMember> &
    typeof publicCreateStaffMember
> = /*#__PURE__*/ createRESTModule(publicCreateStaffMember);
export const getStaffMember: MaybeContext<
  BuildRESTFunction<typeof publicGetStaffMember> & typeof publicGetStaffMember
> = /*#__PURE__*/ createRESTModule(publicGetStaffMember);
export const getDeletedStaffMember: MaybeContext<
  BuildRESTFunction<typeof publicGetDeletedStaffMember> &
    typeof publicGetDeletedStaffMember
> = /*#__PURE__*/ createRESTModule(publicGetDeletedStaffMember);
export const listDeletedStaffMembers: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedStaffMembers> &
    typeof publicListDeletedStaffMembers
> = /*#__PURE__*/ createRESTModule(publicListDeletedStaffMembers);
export const removeStaffMemberFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRemoveStaffMemberFromTrashBin> &
    typeof publicRemoveStaffMemberFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRemoveStaffMemberFromTrashBin);
export const updateStaffMember: MaybeContext<
  BuildRESTFunction<typeof publicUpdateStaffMember> &
    typeof publicUpdateStaffMember
> = /*#__PURE__*/ createRESTModule(publicUpdateStaffMember);
export const deleteStaffMember: MaybeContext<
  BuildRESTFunction<typeof publicDeleteStaffMember> &
    typeof publicDeleteStaffMember
> = /*#__PURE__*/ createRESTModule(publicDeleteStaffMember);
export const countStaffMembers: MaybeContext<
  BuildRESTFunction<typeof publicCountStaffMembers> &
    typeof publicCountStaffMembers
> = /*#__PURE__*/ createRESTModule(publicCountStaffMembers);
export const connectStaffMemberToUser: MaybeContext<
  BuildRESTFunction<typeof publicConnectStaffMemberToUser> &
    typeof publicConnectStaffMemberToUser
> = /*#__PURE__*/ createRESTModule(publicConnectStaffMemberToUser);
export const searchStaffMembers: MaybeContext<
  BuildRESTFunction<typeof publicSearchStaffMembers> &
    typeof publicSearchStaffMembers
> = /*#__PURE__*/ createRESTModule(publicSearchStaffMembers);
export const disconnectStaffMemberFromUser: MaybeContext<
  BuildRESTFunction<typeof publicDisconnectStaffMemberFromUser> &
    typeof publicDisconnectStaffMemberFromUser
> = /*#__PURE__*/ createRESTModule(publicDisconnectStaffMemberFromUser);
export const assignWorkingHoursSchedule: MaybeContext<
  BuildRESTFunction<typeof publicAssignWorkingHoursSchedule> &
    typeof publicAssignWorkingHoursSchedule
> = /*#__PURE__*/ createRESTModule(publicAssignWorkingHoursSchedule);
export const assignCustomSchedule: MaybeContext<
  BuildRESTFunction<typeof publicAssignCustomSchedule> &
    typeof publicAssignCustomSchedule
> = /*#__PURE__*/ createRESTModule(publicAssignCustomSchedule);
export const bulkUpdateStaffMemberTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateStaffMemberTags> &
    typeof publicBulkUpdateStaffMemberTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateStaffMemberTags);
export const bulkUpdateStaffMemberTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateStaffMemberTagsByFilter> &
    typeof publicBulkUpdateStaffMemberTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateStaffMemberTagsByFilter);
export const queryStaffMembers: MaybeContext<
  BuildRESTFunction<typeof customQueryStaffMembers> &
    typeof customQueryStaffMembers
> = /*#__PURE__*/ createRESTModule(customQueryStaffMembers);
/**
 * Triggered when a Wix user is connected to a staff member.
 *
 *
 * The event is triggered when the connection status changes to `CONNECTED`. It
 * isn't triggered when Wix Bookings sends an invitation to become a Wix user or
 * join a site.
 */
export const onStaffMemberConnectedToUser: BuildEventDefinition<
  typeof publicOnStaffMemberConnectedToUser
> &
  typeof publicOnStaffMemberConnectedToUser = createEventModule(
  publicOnStaffMemberConnectedToUser
);
/**
 * Triggered when a staff member is created.
 */
export const onStaffMemberCreated: BuildEventDefinition<
  typeof publicOnStaffMemberCreated
> &
  typeof publicOnStaffMemberCreated = createEventModule(
  publicOnStaffMemberCreated
);
/**
 * Triggered when a staff member is deleted.
 */
export const onStaffMemberDeleted: BuildEventDefinition<
  typeof publicOnStaffMemberDeleted
> &
  typeof publicOnStaffMemberDeleted = createEventModule(
  publicOnStaffMemberDeleted
);
/**
 * Triggered when a Wix user is disconnected from a staff member.
 */
export const onStaffMemberDisconnectedFromUser: BuildEventDefinition<
  typeof publicOnStaffMemberDisconnectedFromUser
> &
  typeof publicOnStaffMemberDisconnectedFromUser = createEventModule(
  publicOnStaffMemberDisconnectedFromUser
);
/**
 * Triggered when a staff member is created.
 */
export const onStaffMemberFullyCreated: BuildEventDefinition<
  typeof publicOnStaffMemberFullyCreated
> &
  typeof publicOnStaffMemberFullyCreated = createEventModule(
  publicOnStaffMemberFullyCreated
);
/**
 * Triggered when a staff member's tags are added, removed, or changed.
 */
export const onStaffMemberTagsModified: BuildEventDefinition<
  typeof publicOnStaffMemberTagsModified
> &
  typeof publicOnStaffMemberTagsModified = createEventModule(
  publicOnStaffMemberTagsModified
);
/**
 * Triggered when a staff member is updated.
 */
export const onStaffMemberUpdated: BuildEventDefinition<
  typeof publicOnStaffMemberUpdated
> &
  typeof publicOnStaffMemberUpdated = createEventModule(
  publicOnStaffMemberUpdated
);

export {
  IdentityType,
  AssociatedWixIdentityConnectionStatusEnumConnectionStatus,
  ConnectionStatus,
  Gender,
  RequestedFields,
  SortOrder,
  Mode,
  ScalarType,
  AggregationType,
  Day,
  Transparency,
  RecurringIntervalType,
  LocationType,
  LocationStatus,
  LocationsLocationType,
  DayOfWeek,
  ApprovalStatus,
  ScheduleStatus,
  ConferenceType,
  CalendarType,
  Status,
  SessionType,
  WebhookIdentityType,
} from './bookings-staff-v1-staff-member-staff-members.universal.js';
export {
  StaffMember,
  MediaItem,
  MediaItemMediaOneOf,
  Resource,
  WorkingHoursSchedule,
  EventSchedule,
  LocationOptions,
  SpecificLocation,
  BusinessLocation,
  AssociatedWixIdentity,
  CommonIdentificationData,
  CommonIdentificationDataIdOneOf,
  Connection,
  AssociatedConferencingProviders,
  AssociatedConferencingProvider,
  AssociatedConferencingAccounts,
  AssociatedConferencingAccount,
  AssociatedConferencingAccountAccountOneOf,
  CustomConferenceAccount,
  ExtendedFields,
  Tags,
  TagList,
  StaffMemberDisconnectedFromUser,
  StaffMemberConnectedToUser,
  StaffMemberFullyCreated,
  TagsModified,
  CreateStaffMemberRequest,
  CreateStaffMemberResponse,
  GetStaffMemberRequest,
  GetStaffMemberResponse,
  GetDeletedStaffMemberRequest,
  GetDeletedStaffMemberResponse,
  ListDeletedStaffMembersRequest,
  CursorPaging,
  ListDeletedStaffMembersResponse,
  CursorPagingMetadata,
  Cursors,
  RemoveStaffMemberFromTrashBinRequest,
  RemoveStaffMemberFromTrashBinResponse,
  RestoreStaffMemberFromTrashBinRequest,
  RestoreStaffMemberFromTrashBinResponse,
  UpdateStaffMemberRequest,
  UpdateStaffMemberResponse,
  DeleteStaffMemberRequest,
  DeleteStaffMemberResponse,
  QueryStaffMembersRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryStaffMembersResponse,
  QueryStaffMembersMultiLanguageRequest,
  QueryStaffMembersMultiLanguageResponse,
  CountStaffMembersRequest,
  CountStaffMembersResponse,
  ConnectStaffMemberToUserRequest,
  ConnectStaffMemberToUserResponse,
  SearchStaffMembersRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  SearchDetails,
  SearchStaffMembersResponse,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  DisconnectStaffMemberFromUserRequest,
  DisconnectStaffMemberFromUserResponse,
  AssignWorkingHoursScheduleRequest,
  AssignWorkingHoursScheduleResponse,
  AssignCustomScheduleRequest,
  AssignCustomScheduleResponse,
  BulkUpdateStaffMemberTagsRequest,
  BulkUpdateStaffMemberTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateStaffMemberTagsResult,
  BulkActionMetadata,
  BulkUpdateStaffMemberTagsByFilterRequest,
  BulkUpdateStaffMemberTagsByFilterResponse,
  RestoreStaffRequest,
  RestoreStaffResponse,
  Empty,
  PolicyRemovedFromContributor,
  PolicyUpdatedForContributor,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  ScheduleNotification,
  ScheduleNotificationEventOneOf,
  ScheduleCreated,
  Schedule,
  RecurringInterval,
  Interval,
  Frequency,
  LinkedSchedule,
  Location,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  LocationsLocation,
  LocationsAddress,
  LocationsStreetAddress,
  LocationsAddressLocation,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Rate,
  Price,
  Availability,
  AvailabilityConstraints,
  SplitInterval,
  Participant,
  ExternalCalendarOverrides,
  Version,
  ConferenceProvider,
  CalendarConference,
  ScheduleUpdated,
  RecurringSessionsUpdated,
  Session,
  CalendarDateTime,
  LocalDateTime,
  ExternalCalendarInfo,
  SessionVersion,
  ParticipantNotification,
  ScheduleCancelled,
  SessionCreated,
  SessionUpdated,
  SessionCancelled,
  AvailabilityPolicyUpdated,
  AvailabilityPolicy,
  IntervalSplit,
  RecurringSessionSplit,
  ScheduleUnassignedFromUser,
  MultipleSessionsCreated,
  ScheduleWithSessions,
  SitePropertiesOnScheduleCreation,
  MigrationEvent,
  MigrationData,
  StaffData,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  StaffMemberConnectedToUserEnvelope,
  StaffMemberCreatedEnvelope,
  StaffMemberDeletedEnvelope,
  StaffMemberDisconnectedFromUserEnvelope,
  StaffMemberFullyCreatedEnvelope,
  StaffMemberTagsModifiedEnvelope,
  StaffMemberUpdatedEnvelope,
  CreateStaffMemberOptions,
  GetStaffMemberOptions,
  GetDeletedStaffMemberOptions,
  ListDeletedStaffMembersOptions,
  UpdateStaffMember,
  UpdateStaffMemberOptions,
  QueryStaffMembersOptions,
  StaffMembersQueryResult,
  StaffMembersQueryBuilder,
  StaffMemberQuerySpec,
  CountStaffMembersOptions,
  ConnectStaffMemberToUserOptions,
  SearchStaffMembersOptions,
  StaffMemberSearchSpec,
  DisconnectStaffMemberFromUserOptions,
  AssignWorkingHoursScheduleOptions,
  AssignCustomScheduleOptions,
  BulkUpdateStaffMemberTagsOptions,
  BulkUpdateStaffMemberTagsByFilterOptions,
} from './bookings-staff-v1-staff-member-staff-members.universal.js';
export { utils } from './bookings-staff-v1-staff-member-staff-members.universal.js';
export {
  IdentityTypeWithLiterals,
  AssociatedWixIdentityConnectionStatusEnumConnectionStatusWithLiterals,
  ConnectionStatusWithLiterals,
  GenderWithLiterals,
  RequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  ModeWithLiterals,
  ScalarTypeWithLiterals,
  AggregationTypeWithLiterals,
  DayWithLiterals,
  TransparencyWithLiterals,
  RecurringIntervalTypeWithLiterals,
  LocationTypeWithLiterals,
  LocationStatusWithLiterals,
  LocationsLocationTypeWithLiterals,
  DayOfWeekWithLiterals,
  ApprovalStatusWithLiterals,
  ScheduleStatusWithLiterals,
  ConferenceTypeWithLiterals,
  CalendarTypeWithLiterals,
  StatusWithLiterals,
  SessionTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateStaffMemberTagsApplicationErrors,
  BulkUpdateStaffMemberTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  StaffMemberQuery,
  CommonSearchWithEntityContext,
  StaffMemberSearch,
} from './bookings-staff-v1-staff-member-staff-members.universal.js';
